// ModalContext.js
import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [title, setTitle] = useState("");
  const [modalBodyClass, setModalBodyClass] = useState("");
  const [size, setSize] = useState("lg");
  const openModal = (content) => {
    setModalContent(content);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  return (
    <ModalContext.Provider
      value={{
        isModalOpen,
        openModal,
        closeModal,
        modalContent,
        fullscreen,
        setFullscreen,
        size,
        title,
        setTitle,
        setSize,
        modalBodyClass,
        setModalBodyClass,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  return useContext(ModalContext);
};
